import { render, staticRenderFns } from "./staff-edit.vue?vue&type=template&id=e62bb5bc&scoped=true&"
import script from "./staff-edit.vue?vue&type=script&lang=ts&"
export * from "./staff-edit.vue?vue&type=script&lang=ts&"
import style0 from "./staff-edit.vue?vue&type=style&index=0&id=e62bb5bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62bb5bc",
  null
  
)

export default component.exports